import { getAuthHeadersWithTokenOnly } from '@discover-frontend/auth';
import { getAccountsApiBaseUrl } from '@discover-frontend/components';

import { TRIAL_STATUS_ENDPOINT } from './constants';

export {
  postTrialUpgradeRequest,
  TrialUpgradeRequestError,
} from '@discover-frontend/components';
export type {
  TrialUpgradeRequestPayload,
  TrialUpgradeRequestResponse,
} from '@discover-frontend/components';

export type TrialStatusResponse = {
  created_at: string;
  query_count: number;
  remaining_queries: number;
  status: string;
  user_email: string;
  user_status: string;
};

export class TrialStatusError extends Error {
  readonly status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = 'TrialStatusError';
    this.status = status;
  }
}

export const isTrialQueryCreationBlocked = (
  trialStatus?: Pick<TrialStatusResponse, 'remaining_queries'>
): boolean => trialStatus?.remaining_queries === 0;

const ACTIVE_TRIAL_STATUS = 'active';

/**
 * Only an explicit `active` status may unblock the authenticated bootstrap.
 * Quota is a per-feature concern handled by `isTrialQueryCreationBlocked`.
 */
export const isTrialActive = (
  trialStatus?: Pick<TrialStatusResponse, 'status'>
): boolean => trialStatus?.status === ACTIVE_TRIAL_STATUS;

export const fetchTrialStatus = async (
  signal?: AbortSignal
): Promise<TrialStatusResponse> => {
  const url = `${getAccountsApiBaseUrl()}${TRIAL_STATUS_ENDPOINT}`;

  const headers: Record<string, string> = {
    Accept: 'application/json',
    ...getAuthHeadersWithTokenOnly(),
  };

  const response = await fetch(url, {
    method: 'GET',
    headers,
    signal,
  });

  const data = (await response.json().catch(() => ({}))) as TrialStatusResponse;

  if (!response.ok) {
    throw new TrialStatusError(
      (data as { message?: string }).message || response.statusText,
      response.status
    );
  }

  return data;
};
